import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData, postData } from "../../utility/Utility";
import Swal from "sweetalert2";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";

function FinalReport() {
  const navigate = useNavigate();
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const rowsPerPage = 10;

  const fetchCommissions = async (page = 1, search = "") => {
    setLoading(true);
    try {
      const response = await getData("api/admin/commissions", {
        page: page,
        limit: rowsPerPage,
        search: search
      });

      if (response?.success) {
        setCommissions(response.data.commissions);
        setTotalPages(response.data.pagination.totalPages);
      } else {
        toast.error(response?.message || "Failed to fetch commissions");
      }
    } catch (error) {
      toast.error("Error fetching commissions");
      console.error("Fetch commissions error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommissions(currentPage + 1, searchTerm);
  }, [currentPage, searchTerm]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(0);
    fetchCommissions(1, searchTerm);
  };

  const handleReset = () => {
    setSearchTerm("");
    setCurrentPage(0);
    fetchCommissions(1);
  };

  const handleDelete = async (_id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await postData(`api/admin/commissions/delete`, {
          commissionId: _id
        });
        

        if (response?.success) {
          toast.success(response.message || "Commission deleted successfully");
          fetchCommissions(currentPage + 1, searchTerm);
        } else {
          toast.error(response?.message || "Failed to delete commission");
        }
      } catch (error) {
        toast.error("Error deleting commission");
        console.error("Delete commission error:", error);
      }
    }
  };

  const handleStatusChange = async (commission) => {
    const newStatus = commission.status === "active" ? "inactive" : "active";

    const result = await Swal.fire({
      title: `Are you sure you want to ${newStatus === "active" ? "activate" : "deactivate"} this commission?`,
      text: `The commission will be ${newStatus === "active" ? "activated" : "deactivated"}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${newStatus === "active" ? "activate" : "deactivate"} it!`,
    });

    if (result.isConfirmed) {
      try {
        const response = await postData(`api/admin/commissions/update`, {
          commissionId: commission.commissionId,
        });

        
        if (response?.success) {
          toast.success(response.message || "Commission updated successfully");
          fetchCommissions(currentPage + 1, searchTerm);
        } else {
          toast.error(response?.message || "Failed to update commission");
        }
      } catch (error) {
        toast.error("Error updating commission");
        console.error("Update commission error:", error);
      }
    }
  };




  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Final Report Management</h4>
              <p className="fw-semibold my-2">Final Report List</p>
            </div>
            <div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-12 col-lg-4">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control ps-4"
                            placeholder="Search commissions..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i className="mdi mdi-magnify"></i>
                          </span>
                        </div>
                      </div>

                      <div className="col-md-12 col-lg-3 d-flex gap-2">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Searching..." : "Search"}
                        </button>

                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleReset}
                          disabled={loading}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Agent Name</th>
                          <th>Policy Holder</th>
                          <th>Sale Amount</th>
                          <th>Commission</th>
                          <th>Percentage</th>
                          <th>level</th> 
                          <th>Type</th>
                          <th>Status</th>
                          <th>Created At</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="15" className="text-center py-4">
                              Loading reports...
                            </td>
                          </tr>
                        ) : commissions.length === 0 ? (
                          <tr>
                            <td colSpan="15" className="text-center py-4">
                              No reports found
                            </td>
                          </tr>
                        ) : (
                          commissions.map((commission, index) => (
                            <tr key={commission._id}>
                              <td>{currentPage * rowsPerPage + index + 1}</td>
                              <td>
                                {commission.agent_id?.fullName || 'N/A'}
                                <br />
                                {commission.agent_id?.email || ''}
                              </td>
                              <td>
                                {commission.policy_sale_id?.user_id?.fullName || 'N/A'}
                                <br />
                                {commission.policy_sale_id?.amount ? `₹${commission.policy_sale_id?.amount}` : ''}
                              </td>
                              <td>₹{commission.sale_amount || commission.policy_sale_id?.amount || '0'}</td>
                              <td>₹{commission.amount}</td>
                              <td>{commission.percentage}%</td>
                              <td>{commission.level}</td>
                              <td>{commission.type}</td>
                              <td>
                                <span className={`badge ${commission.status === 'pending' ? 'bg-warning' : 'bg-success'}`}>
                                  {commission.status}
                                </span>
                              </td>
                              <td>{new Date(commission.created_at || commission.createdAt).toLocaleDateString()}</td>
                              <td>
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() =>
                                        navigate(`/update-commission`, {
                                          state: { categoryData: commission },
                                        })
                                      }
                                    >
                                      <i className="mdi mdi-pencil"></i>
                                    </button>
                                    <button
                                      className={`btn btn-sm btn-outline-${commission.status === 'active' ? 'warning' : 'success'}`}
                                      onClick={() => handleStatusChange(commission)}
                                      title={commission.status === 'active' ? 'Deactivate' : 'Activate'}
                                    >
                                      <i className={`mdi mdi-${commission.status === 'active' ? 'close' : 'check'}`}></i>
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleDelete(commission._id)}
                                    >
                                      <i className="mdi mdi-delete"></i>
                                    </button>
                                  </div>
                                </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                    {totalPages > 1 && (
                      <ReactPaginate
                        previousLabel={<i className="mdi mdi-chevron-left"></i>}
                        nextLabel={<i className="mdi mdi-chevron-right"></i>}
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination pagination-rounded justify-content-end mt-3"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                        forcePage={currentPage}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinalReport;
